const ACCENT = '#0E243E';

interface PageHeaderTabsProps {
  tabs: string[];
  active: number;
  onChange: (index: number) => void;
  accentColor?: string;
}

export function PageHeaderTabs({ tabs, active, onChange, accentColor }: PageHeaderTabsProps) {
  const accent = accentColor || ACCENT;

  return (
    <div
      style={{
        display: 'flex',
        gap: 0,
        background: '#fff',
        borderBottom: '1px solid #d5d5d5',
        paddingLeft: 32,
        flexShrink: 0,
        boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
      }}
    >
      {tabs.map((t, i) => (
        <button
          key={i}
          onClick={() => onChange(i)}
          style={{
            padding: '16px 24px',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: 0.8,
            color: active === i ? 'rgba(0,0,0,0.87)' : 'rgba(0,0,0,0.54)',
            borderBottom: active === i ? `3px solid ${accent}` : '3px solid transparent',
            transition: 'all 0.15s',
            fontFamily: 'inherit',
          }}
          onMouseEnter={(e) => {
            if (active !== i) (e.currentTarget as HTMLElement).style.backgroundColor = '#F8F8F8';
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLElement).style.backgroundColor = 'transparent';
          }}
        >
          {t}
        </button>
      ))}
    </div>
  );
}
